import { Component } from 'react'
import { initHotJar } from './HotJar'
import { initApplicationInsights } from './ApplicationInsights'

class Analytics extends Component {
  constructor () {
    super()
    this.sendPageLoad = this.sendPageLoad.bind(this)
    this.ai = null
    this.state = { lastPathName: undefined }
    // save in the analytics export also so we can call from getDerivedStateFromProps as that's how we
    // know the pathname changed
    Analytics.sendPageLoad = this.sendPageLoad
  }

  static getDerivedStateFromProps (props, state) {
    if (state.lastPathName !== window.location.pathname) {
      Analytics.sendPageLoad(window.location.pathname)
      return { lastPathName: window.location.pathname }
    } else {
      return null
    }
  }

  componentDidMount () {
    if (this.props.config.hotjarKey) {
      initHotJar(this.props.config.hotjarKey)
    }

    if (this.props.config.applicationInsightsKey) {
      this.ai = initApplicationInsights(this.props.config.applicationInsightsKey)
    }
    this.sendPageLoad(window.location.pathname)
  }

  sendPageLoad (path) {
    if (!this.ai) return
    if (this.props.config.applicationInsightsKey) {
      this.ai.trackPageView(
        path,
        path,
        {
          'screen-resolution': `${window.screen.width}x${window.screen.height}`,
          'screen-width': window.screen.width,
          'screen-height': window.screen.height,
          'pixel-depth': window.screen.pixelDepth,
          'window-innerHeight': window.innerHeight,
          'window-innerWidth': window.innerWidth
        })
    }
  }

  render () { return null }
}

export default Analytics



// WEBPACK FOOTER //
// ./src/util/analytics/Analytics.js